<template>
  <img class="banner-image" src="../assets/toppic/图片-05.jpg"/>
<!--  <div class="panel-div">-->
<!--    <div class="title-panel-name">-->
<!--      <div  v-for="(item,index) in companyinfoList" :key="item.id">-->
<!--        <span :class="{'panel-span active':activeName == item.title,'panel-span':activeName != item.title,}" @click="changePanel(index)">{{item.title}}</span>-->
<!--        <span v-if="index < companyinfoList.length - 1">|</span>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="content-div" v-for="item in companyinfoList" :key="item.title" >-->
<!--      <div class="content-item"  v-if="activeName == item.title" v-html="item.content"></div>-->
<!--    </div>-->
<!--  </div>-->
  <div class="panel-div" v-for="item in companyinfoList" :key="item.id">
    <div class="title-panel-name">
      <div>
        <span class="panel-span active">{{item.title}}</span>
      </div>
    </div>
    <div class="content-div">
      <div class="content-item"  v-html="item.content"></div>
    </div>
  </div>
</template>

<script>
import{ companyinfo } from "@/api/AboutMe";

export default {
  name: 'AboutMe',

  props: {
    msg: String
  },
  data(){
    return {
      companyinfoList:[],
      activeName:null
    }
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    var languageStr = localStorage.getItem("website-language");

    if(!languageStr){
      var intervalIndex = setInterval(() =>{
        var languageStr = localStorage.getItem("website-language");
        if(languageStr){
          clearInterval(intervalIndex);
          this.language = JSON.parse(languageStr);
          this.initData();
        }
      },100);
    }else{
      this.language = JSON.parse(languageStr);
      this.initData();
    }
  },
  methods: {
    initData() {
      companyinfo({id:this.language.id}).then(res => {
        console.log(res);
        this.companyinfoList = res.data;
        this.activeName = this.companyinfoList[0].title;
      });
    },
    changePanel(index) {
      this.activeName = this.companyinfoList[index].title;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel-div{
  padding:20px 35px;
  text-align: left;
}
.panel-div .title-panel-name{
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;
  margin:20px 10px;
  margin-bottom: 60px;
}


.content-item{
  text-align: left;
  text-indent: 2em;
}

.content-item>>> img{
  display: block;
  margin: 10px auto;
  width:100%;
}

@media (max-width: 720px) {

  .panel-div{
    padding:20px 10px;
  }
  .content-item>>> img{
    display: block;
    margin: 10px auto;
    width:100%;
  }
}


.panel-div .title-panel-name .panel-span{
  display: inline-block;
  background-color: #EFEFEF;
  margin:6px 13px;
  padding:8px 18px;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  color:#303133;
}
.panel-div .title-panel-name .panel-span:hover{
  font-weight: 700;
  color:#1890ff;
  background-color:#e9f4ff;
}
.panel-div .title-panel-name .active{
  font-weight: 700;
  color:#1890ff;
  background-color:#e9f4ff;
}
</style>
